import { useCallback, useLayoutEffect, useState } from 'react';

const useResizeObserver = (elementRef, callback = null) => {

  const [ dimensions, setDimensions ] = useState({
    width: 0,
    height: 0
  });

  const handleResize = useCallback((entries) => {
    if (!Array.isArray(entries)) {
      return;
    }

    const entry = entries[0];
    setDimensions({
      width: entry.contentRect.width,
      height: entry.contentRect.height
    });

    if (callback) {
      callback({
        width: entry.contentRect.width,
        height: entry.contentRect.height
      });
    }
  }, [ callback ]);

  useLayoutEffect(() => {
    if (!elementRef.current) {
      return;
    }

    let resizeObserver = new ResizeObserver((entries) => {
      handleResize(entries);
    });
    resizeObserver.observe(elementRef.current);

    return () => {
      resizeObserver.disconnect();
      resizeObserver = null;
    };
  }, [ elementRef ]);

  return dimensions;
};

export default useResizeObserver;
